(() => {
  // custom event polyfill
  if (typeof window.CustomEvent !== 'function') {
    let CustomEvent = (event, params) => {
      params = params || { bubbles: false, cancelable: false, detail: undefined }
      let evt = document.createEvent('CustomEvent')
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
      return evt
    }
    CustomEvent.prototype = window.Event.prototype
    window.CustomEvent = CustomEvent
  }

  // insided js api
  let cookieLevels = ['required', 'anonymous', 'all']

  let getCookieValue = a => {
    let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)')
    return b ? b.pop() : ''
  }

  let setCookieLevels = levels => {
    cookieLevels = levels
  }

  let getPrivacyLevel = () => {
    return getCookieValue('cookiePrivacyLevel')
  }

  let isAllowed = level => {
    return cookieLevels.indexOf(getPrivacyLevel()) >= cookieLevels.indexOf(level)
  }

  let addElement = (params) => {
    let tag = document.createElement(params.tag)
    delete params.tag
    for (let param in params) {
      tag.setAttribute(param, params[param])
    }
    document.head.appendChild(tag)
  }

  let addTag = (params, level = 'all') => {
    if (!params.tag || !isAllowed(level)) {
      return
    }
    if (params.tag === 'script') {
      return addScript(params, level)
    }
    addElement(params)
  }

  let addScript = (params, level = 'all') => {
    if (!params.src || !isAllowed(level)) {
      return
    }
    params.tag = 'script'
    addElement(params)
  }

  let addGA = (id, level = 'all') => {
    let src = 'https://www.googletagmanager.com/gtag/js?id=' + id
    addScript({
      src: src,
      async: true
    }, level)

    window.dataLayer = window.dataLayer || []
    window.gtag = (...args) => window.dataLayer.push(args)
    window.gtag('js', new Date())
    window.gtag('config', id)
  }

  let api = {
    addGA: addGA,
    addScript: addScript,
    addTag: addTag,
    getPrivacyLevel: getPrivacyLevel,
    setCookieLevels: setCookieLevels
  }

  let ce = new window.CustomEvent('insided:loaded', { detail: api })

  document.dispatchEvent(ce)
})()
